export const raceKeys = {
  all: ["tsp", "race"] as const,
  list: (filters?: {
    discipline?: string
    circuit?: string
    gender?: string
    year?: string
  }) => [...raceKeys.all, "list", filters ?? {}] as const,
  detail: (id: string | number) => [...raceKeys.all, "detail", id] as const,
  withRuns: (id: string | number) =>
    [...raceKeys.all, "with_runs", id] as const,
  judgeAnalysis: (filters: {
    circuit?: string
    gender?: string
    year?: string
  }) => [...raceKeys.all, "judge_analysis", filters] as const,
  circuits: () => [...raceKeys.all, "circuits"] as const,
}
